module.exports = __webpack_public_path__ + "img/plafon.87895e60.png";